import { createSelector } from "reselect";
import { loadQuoteAwnings, updateQuoteAwning } from ".";
import store, { type AppDispatch, type AppState, UsePortalSelector } from "../..";
import type { QuoteAccessoryStore } from "../../../powershadesApiTypes";
import { loadStatus } from "../entitiesType";
import type {
    UpdateAwningThunkInput
} from "./awningThunkTypes";

export const selectQuoteAwningsUnsafe = (state: AppState) => state.entity.quoteAwnings;

export const selectQuoteAwnings = (quoteId: number) => createSelector(
    selectQuoteAwningsUnsafe, (quoteAwnings) => {
        const qaItem = quoteAwnings[quoteId];

        if (!qaItem
            || qaItem?.loadStatus === loadStatus.notLoaded
            || qaItem?.loadStatus === loadStatus.needsLoaded) {
            store.dispatch(loadQuoteAwnings(quoteId));
        }

        let qaList: QuoteAccessoryStore[] = [];

        const qaItems = quoteAwnings[quoteId];

        if (qaItems) {
            qaList = Object.values(qaItems.Items);
        }

        return qaList;
    }
);

export const selectQuoteAwning = (quoteId: number, lineNumber: number) => createSelector(
    selectQuoteAwnings(quoteId), (qaList) => qaList.find((qa) => qa.line_number === lineNumber)
);

/**
 * Hook for updating a quote Awning
 * @returns A function that takes a UpdateAwningThunkInput and dispatches the updateQuoteAwning action
 */
export const useUpdateQuoteAwning = () => (updateQuoteAwningInput: UpdateAwningThunkInput ) => {
    const { dispatch } = store;

    const typedDispatch = dispatch as AppDispatch;

    typedDispatch(
        updateQuoteAwning({... updateQuoteAwningInput })
    );
};

export const useQuoteAwnings = (quoteId: number) => UsePortalSelector(selectQuoteAwnings(quoteId));
export const useQuoteAwning = (quoteId: number, lineNumber: number) => UsePortalSelector(selectQuoteAwning(quoteId, lineNumber));
